/**
 * Centralized routing constants and helpers
 * This prevents typos and makes refactoring easier
 */

export const ROUTES = {
  // Public routes
  home: '/',
  auth: '/auth',
  about: '/about',
  pricing: '/pricing',
  contact: '/contact',
  feedback: '/feedback',
  terms: '/terms',
  privacy: '/privacy',

  // Checkout routes
  checkoutSuccess: '/checkout/success',
  checkoutCancel: '/checkout/cancel',

  // Authenticated routes
  explore: '/explore',
  exploreMapbox: '/explore-mapbox',
  activity: '/activity',
  dashboard: '/dashboard',
  settings: '/settings',
  logRun: '/log-run',
  uploadRun: '/upload/run',
  onboarding: '/onboarding',
  gpxTracksGuide: '/help/gpx-tracks',

  // Detail routes with ID parameters
  trail: (id: string) => `/trails/${id}`,
  route: (id: string) => `/routes/${id}`,
  run: (id: string) => `/runs/${id}`,
  runEdit: (id: string) => `/runs/${id}/edit`,
  feature: (id: string) => `/feature/${id}`,
  profile: (userId: string) => `/profile/${userId}`,

  // Event routes
  events: '/events',
  eventsCreate: '/events/create',
  eventDetail: (id: string) => `/events/${id}`,
  eventEdit: (id: string) => `/events/${id}/edit`,
} as const;

/**
 * Type-safe route builder
 * Usage: buildRoute(ROUTES.run, runId)
 */
export function buildRoute<T extends (...args: any[]) => string>(
  routeFn: T,
  ...args: Parameters<T>
): string {
  return routeFn(...args);
}
